/* ============================================================
   AUREM HOME — Product Gallery Enhancements
   Mobile pinch-to-zoom + touch improvements
   ============================================================ */

(function() {
  'use strict';

  /* --- MOBILE PINCH-TO-ZOOM --- */
  class AuremPinchZoom {
    constructor() {
      this.scale = 1;
      this.startDistance = 0;
      this.startScale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.startX = 0;
      this.startY = 0;
      this.isPinching = false;
      this.isPanning = false;
      this.activeImage = null;
      this.overlay = null;
      this.maxScale = 3;
      this.init();
    }

    init() {
      // Only activate on touch devices
      if (!('ontouchstart' in window)) return;

      document.querySelectorAll('.product__media-list .product__media img').forEach(img => {
        img.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
      });
    }

    getDistance(t1, t2) {
      return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
    }

    getMidpoint(t1, t2) {
      return {
        x: (t1.clientX + t2.clientX) / 2,
        y: (t1.clientY + t2.clientY) / 2
      };
    }

    handleTouchStart(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        e.stopPropagation();
        this.isPinching = true;
        this.activeImage = e.target.closest('img');
        this.startDistance = this.getDistance(e.touches[0], e.touches[1]);
        this.startScale = this.scale;

        if (!this.overlay) this.createOverlay();

        this.activeImage.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
        this.activeImage.addEventListener('touchend', this.handleTouchEnd.bind(this));
      }
    }

    handleTouchMove(e) {
      if (e.touches.length === 2 && this.isPinching) {
        e.preventDefault();
        const dist = this.getDistance(e.touches[0], e.touches[1]);
        const newScale = Math.min(this.maxScale, Math.max(1, this.startScale * (dist / this.startDistance)));
        this.scale = newScale;
        this.applyTransform();
      } else if (e.touches.length === 1 && this.scale > 1) {
        e.preventDefault();
        if (!this.isPanning) {
          this.isPanning = true;
          this.startX = e.touches[0].clientX - this.translateX;
          this.startY = e.touches[0].clientY - this.translateY;
        }
        this.translateX = e.touches[0].clientX - this.startX;
        this.translateY = e.touches[0].clientY - this.startY;
        this.applyTransform();
      }
    }

    handleTouchEnd(e) {
      if (e.touches.length < 2) {
        this.isPinching = false;
      }
      if (e.touches.length === 0) {
        this.isPanning = false;
        if (this.scale <= 1.05) this.resetZoom();
      }
    }

    createOverlay() {
      if (!this.activeImage) return;
      this.overlay = document.createElement('div');
      this.overlay.className = 'aurem-pinch-overlay';
      this.overlay.innerHTML = '<span class="aurem-pinch-hint">Pinch to zoom</span>';
      this.activeImage.closest('.product-media-container').appendChild(this.overlay);
      setTimeout(() => { if (this.overlay) this.overlay.querySelector('.aurem-pinch-hint').style.opacity = '0'; }, 1500);
    }

    applyTransform() {
      if (!this.activeImage) return;
      this.activeImage.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
      this.activeImage.style.zIndex = this.scale > 1 ? '10' : '';
    }

    resetZoom() {
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
      if (this.activeImage) {
        this.activeImage.style.transform = '';
        this.activeImage.style.zIndex = '';
      }
      if (this.overlay) {
        this.overlay.remove();
        this.overlay = null;
      }
    }
  }

  /* --- DOUBLE-TAP TO ZOOM (mobile) --- */
  class AuremDoubleTapZoom {
    constructor() {
      this.lastTap = 0;
      this.zoomed = false;
      this.init();
    }

    init() {
      if (!('ontouchstart' in window)) return;

      document.querySelectorAll('.product__media-list .product__media img').forEach(img => {
        img.addEventListener('touchend', (e) => {
          if (e.touches.length > 0) return;
          const now = Date.now();
          if (now - this.lastTap < 300) {
            e.preventDefault();
            this.toggleZoom(img, e);
          }
          this.lastTap = now;
        });
      });
    }

    toggleZoom(img, e) {
      if (this.zoomed) {
        img.style.transform = '';
        img.style.transformOrigin = '';
        img.style.zIndex = '';
        this.zoomed = false;
      } else {
        const rect = img.getBoundingClientRect();
        const touch = e.changedTouches[0];
        const x = ((touch.clientX - rect.left) / rect.width) * 100;
        const y = ((touch.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(2.5)';
        img.style.zIndex = '10';
        this.zoomed = true;
      }
    }
  }

  /* --- INIT --- */
  function initGalleryEnhancements() {
    new AuremPinchZoom();
    new AuremDoubleTapZoom();

    // Add image count indicator on mobile
    const gallery = document.querySelector('.product__media-list');
    if (gallery && window.innerWidth < 750) {
      const slides = gallery.querySelectorAll('.product__media-item');
      if (slides.length > 1) {
        const counter = document.querySelector('.slider-counter');
        if (counter) {
          counter.classList.add('aurem-gallery-counter');
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryEnhancements);
  } else {
    initGalleryEnhancements();
  }
})();
